import {
  createRootRoute,
  createRoute,
  createRouter,
} from "@tanstack/react-router";
import "./index.css";
import { DigitailPage } from "./pages/DigitailPage";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { RootLayout } from "./pages/RootLayout";
import { ToolPage } from "./pages/ToolPage";
import { ToolsPage } from "./pages/ToolsPage";

const rootRoute = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomePage,
});

const allToolsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/tools",
  component: ToolsPage,
});

const toolsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/tools/$toolSlug",
  component: ToolPage,
});

const digitailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/digitail",
  component: DigitailPage,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  allToolsRoute,
  toolsRoute,
  digitailRoute,
]);

export const router = createRouter({
  routeTree,
  scrollRestoration: true,
  scrollRestorationBehavior: "instant",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
